import { render, staticRenderFns } from "./GenviteConflicts.vue?vue&type=template&id=2c79a028&"
import script from "./GenviteConflicts.vue?vue&type=script&lang=js&"
export * from "./GenviteConflicts.vue?vue&type=script&lang=js&"
import style0 from "./GenviteConflicts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports